import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			click: {
				prev: 'prev',
				next: 'next',
				author: 'goto'
			}
		}
    }

    init() {
		this.swiper = new Swiper(this.el, {
			speed: 800,
			// loop: true,
			effect: 'fade'
		});

		this.$slides = this.$('slide');
		this.$authors = this.$('author');

		gsap.delayedCall(window.readyCallbackDelay,() => {
			// First hit
			let scrambleEl = this.swiper.slides[this.swiper.activeIndex].querySelector("[data-module-scramble");
			this.call('display',{},'Scramble',scrambleEl.getAttribute('data-module-scramble'));
			
			this.oldSlide = this.swiper.slides[this.swiper.activeIndex];

			this.checkAuthor();
		});

		this.swiper.on('slideChange', (e) => {
			
			if(this.oldSlide != null) {
				let oldScrambleEl = this.oldSlide.querySelector("[data-module-scramble");
				this.call('hide',{},'Scramble',oldScrambleEl.getAttribute('data-module-scramble'));
			}

			gsap.delayedCall(0.3,() => {
				let scrambleEl = this.swiper.slides[this.swiper.activeIndex].querySelector("[data-module-scramble");
				this.call('display',{},'Scramble',scrambleEl.getAttribute('data-module-scramble'));
			});

			this.oldSlide = this.swiper.slides[this.swiper.activeIndex];

			this.checkAuthor();
		});
    }

	prev() {

		if(this.swiper.activeIndex > 0) {
			this.swiper.slidePrev();
		} else {
			this.swiper.slideTo(this.$slides.length - 1);
		}
	}
	next() {
		if(this.swiper.activeIndex < this.$slides.length - 1) {
			this.swiper.slideNext();
		} else {
			this.swiper.slideTo(0);
		}
	}

	goto(e) {
		let idx = parseInt(e.currentTarget.getAttribute('data-slide'));
		this.swiper.slideTo(idx);
	}

	checkAuthor() {
		this.$authors.forEach(author => {
			if(author.getAttribute('data-slide') == this.swiper.activeIndex) {
				author.classList.add('is-active');
			} else {
				author.classList.remove('is-active');
			}
		})
	}
	
}
